import React, { useContext, useState, useEffect, useRef } from 'react';
import '../../../Styles/OpenOrders.scss'
import OpenOrders__GridView from './OpenOrders__GridView';
import useFetch from 'CustomHooks/useFetch';
import { GlobalContext } from '../../../Contexts/GlobalContext';
import useOptionGroups from '../../OptionGroups/useOptionGroups';
import useCustomerSettings from 'CustomHooks/useCustomerSettings';
import CallTheWaiter from '../../CallTheWaiter/CallTheWaiter';
import useGuiTranslations from '../../../Components/MultiLanguage/useGuiTranslations';
import NoOrdersYet from './NoOrdersYet';
import WarningOnOpenOrdersPage from '../../PushNotifications/WarningOnOpenOrdersPage';
import useOneSignal from '../../../CustomHooks/useOneSignal';

export default function OpenOrders(props) {

  const [getOpenOrdersResponse, getOpenOrders] = useFetch();
  const [orders, setOrders] = useState([]);
  const globalContext = useContext(GlobalContext);
  const [optionGroupsHookResponse, optionGroupsHook] = useOptionGroups();
  const [currency, setCurrency] = useState('');
  const getCustomerSettingsHookResponse = useCustomerSettings();
  const timerId = useRef(null);
  const audio = new Audio('/telephone-ring.mp3');
  const [translateGui] = useGuiTranslations();
  const sendOneSignalIdFunc = useOneSignal();



  useEffect(
    () => {

      const f = async () => {

        //window.indexedDB.databases()
        let arr = await window.indexedDB.databases();
        if(arr.filter(db => db.name.indexOf('ONE_')>-1).length>0){
          console.log('mo');  
          var request = window.indexedDB.open("ONE_SIGNAL_SDK_DB")
        //arr.filter(db => db.name.indexOf('ONE_')>-1))

        request.onerror = function (event) {
          console.log("Why didn't you allow my web app to use IndexedDB?!");
        };
        request.onsuccess = function (event) {
          let db = event.target.result;
          console.log(db);

          db.transaction("Ids").objectStore("Ids").get("userId").onsuccess = function (event) {
            console.log("Name for SSN 444-44-4444 is " + event.target.result.id);
            sendOneSignalIdFunc(event.target.result.id);
          };


          db.onerror = function (event) {
            // Generic error handler for all errors targeted at this database's
            // requests!
            console.error("Database error: " + event.target.errorCode);
          };

        };
        }
        else {
          console.log('no index db for onesignal');
        }
        

      }
      f();
    }, []
  )

  useEffect(
    () => {
      if (getCustomerSettingsHookResponse.currency != null) {
        setCurrency(getCustomerSettingsHookResponse.currency.toUpperCase());
      }
      //console.log(getCustomerSettingsHookResponse);
    }, [getCustomerSettingsHookResponse]
  )


  const getOrders = () => {
    //console.log('getting orders');

    getOpenOrders(
      {
        url: '/admin/orders?OrderStatus=Preparing&PaymentStatus=Completed&PageNumber=1&PageSize=50',
        addTokenHeader: true,
        method: 'GET',
        postData: null,
      }
    );
  }

  useEffect(
    () => {
      if (optionGroupsHookResponse.foodOptionGroups) {
        console.log(optionGroupsHookResponse);
        //getOrders();
      }
    }, [optionGroupsHookResponse]
  )

  useEffect(
    () => {
      //window.gtag('config', 'UA-160225157-2', { 'page_path': '/OpenOrders' });
    }, []
  )

  useEffect(
    () => {

      globalContext.dispatchMethod(
        {
          type: 'SET_MENU_LOCATION',
          value: {
            a: 1,
            b: 2,
          },
        }
      )


    }, []
  )


  useEffect(
    () => {
      //console.log(timerId);
      if (getOpenOrdersResponse.orderList == null) {
        if (!timerId.current) {
          timerId.current = setInterval(getOrders, 5000);
        }
      }
    }, [getOpenOrdersResponse]
  )


  useEffect(
    () => {
      return () => { clearInterval(timerId.current) }
    }, []
  )


  useEffect(
    () => {
      //console.log(getOpenOrdersResponse);
      if (getOpenOrdersResponse.orderList != null) {
        let newOrders = [];
        let existingOrders = [...orders];
        let filteredExistingOrders = [];
        let ringTheBell = false;
        getOpenOrdersResponse.orderList.map(
          order => {
            if (orders.filter(orderFiltered => orderFiltered.orderNumber == order.orderNumber).length < 1) {
              //console.log(order);
              //NEW ORDER bu yeni ordermis cunku mevcut listede yok
              newOrders.push(order);//TODO: bu array'i printer'a da gondermek lazim
              ringTheBell = true;
            }
          }
        )

        //new order gelmis
        if (ringTheBell) {
          audio.play();
          if (globalContext.globalState.userInteractedWithTheDocument) {
            console.log('ring the bell');

          }
          else {
            console.log('can not ring the bell');
          }
        }

        //eger order artik gelmiyor ise butun itemlar serve edilmistir, listeden cikariyorum
        filteredExistingOrders = existingOrders.filter(
          existingOrder => getOpenOrdersResponse.orderList.filter(orderFromServer => orderFromServer.id == existingOrder.id).length > 0
        )

        setOrders([...filteredExistingOrders, ...newOrders]);
      }
    }, [getOpenOrdersResponse]
  )

  return (
    <React.Fragment>
      {
        (orders.length > 0) ?
          <WarningOnOpenOrdersPage></WarningOnOpenOrdersPage>
          : null
      }
      <CallTheWaiter></CallTheWaiter>
      {
        (orders.length > 0) ?
          <OpenOrders__GridView currency={currency} orderList={orders} optionGroups={optionGroupsHookResponse.foodOptionGroups}></OpenOrders__GridView>
          : <div className="flex-horizontal-center no-pending-order">
            <NoOrdersYet></NoOrdersYet>
          </div>
      }
    </React.Fragment>
  );
}
